export const excludePath = [
  '/assets/',
  '/static/',
  '/media/',
  '/api/customers/me',
  '/api/rental-contracts/my',
]

export const excludeContent = [
  'Network Error',
  'Token has expired and can no longer be refreshed',
  'Unauthenticated',
  'Too Many Attempts.',
  'This action is unauthorized',
  'No query results for model [Modules\\Drivers\\Models\\RentalContract].',
]

export const excludeStatusCodes = [422, 404, 401]
